import React, { useState } from 'react';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import MaterialTable from 'material-table';
import { useTheme } from '@material-ui/core';
import DocumentsDetails from './DocumentsDetails';
import withAppStylesGrid from 'HOCs/withAppStyles';
import { getProjectDocuments,Document } from 'utils/DocumentsUtils';


export default function GridDocuments({ customFilter,callback }) {
  const columns =Document.columns
  const theme = useTheme();

  const { selectedProject } = useAppContext();
  const [updateDate,setUpdateDate] = useState(new Date());
  const [page, setPage] = useState(0);
  const title = "Documents";

  const DataGrid = withAppStylesGrid(MaterialTable, { defaultFilters: { projectId: selectedProject, ...customFilter }, theme, getRecords: getProjectDocuments })
   

  return (
    selectedProject && theme ?
      <>
        <>
          <DataGrid
            key={updateDate}
            style={{ boxShadow: "0 0 0 0" }}
            padding="dense"
            columns={columns}
            title={title}
            options={{
              headerStyle: {
                backgroundColor: theme.palette.grey[50],
                color: theme.palette.text.primary,
              },
              onPageChange: (e) => setPage(e),
              initialPage: page,
              pageSize: 10,
              pageSizeOptions: [10, 15, 25]
            }}
            detailPanel={rowData => {
              return (
                <DocumentsDetails documentistItem={rowData}  callback={() => setUpdateDate(new Date)}></DocumentsDetails>
              )
            }}
          />
        </>
      </> : <SkeletonGrid title={title} />
  )
}